import styled from 'styled-components';

const UptimeIndicator = styled.div`
  font-weight: bold;
  padding: 0.75rem 0;
  background-color: ${({ background }) => background};
  color: #fff;
  border-radius: 12px;
  width: 4rem;
  height: 2.5rem;
  font-size: 1rem;
  text-align: center;
  flex-grow: 0;
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// `unknown` covers a percentage that has not been established: a failed query,
// or a location with no eligible cameras. The pill keeps its fixed width so the
// column does not shift when a row resolves.
export const VariableUptimeIndicator = ({
  value,
  lowerThreshold = 0.8,
  upperThreshold = 0.95,
  unknown = false,
  title,
}) => {
  const fixedValue = isNaN(value) ? 0 : value;
  const uptimePercent = isNaN(value) ? 0 : value * 100;
  return (
    <Wrapper title={title}>
      <UptimeIndicator
        background={() => {
          if (unknown) return 'var(--mid-grey)';
          if (fixedValue < lowerThreshold) return 'var(--error)';
          if (fixedValue >= lowerThreshold && fixedValue < upperThreshold)
            return 'var(--warning)';
          return 'var(--ok)';
        }}
      >
        {unknown ? '—' : `${Math.round(uptimePercent)}%`}
      </UptimeIndicator>
    </Wrapper>
  );
};
